// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"Table_tableRow__2_uKn"};